import { Button, Text } from '@/ui-kit'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/ui-kit/components/Dialog'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

export type RestartVoteState = {
  activeRestartId: string | null
  hasVoted: boolean
  isRequester: boolean
  requiredVotes: number
  yesCount: number
  noCount: number
}

type RestartVoteDialogProps = {
  open: boolean
  restart: RestartVoteState
  restartPending: boolean
  onVoteRestart: (vote: boolean) => void
}

export function RestartVoteDialog({ open, restart, restartPending, onVoteRestart }: RestartVoteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle className="text-xl!">
            <Trans>Restart recording?</Trans>
          </DialogTitle>
          <DialogDescription>
            {restart.isRequester
              ? t`Waiting for other participants to vote...`
              : t`The other participant wants to restart the recording.`}
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center justify-center gap-2 py-2">
          <Text type="body2-regular" className="text-gray-80">
            {restart.yesCount}/{restart.requiredVotes} <Trans>votes needed</Trans>
          </Text>
        </div>
        <DialogFooter>
          {restart.isRequester || restart.hasVoted || restartPending ? (
            <Text type="body2-regular" className="text-gray-80">
              {restart.isRequester || restartPending ? (
                <Trans>You requested this restart</Trans>
              ) : (
                <Trans>Vote submitted</Trans>
              )}
            </Text>
          ) : (
            <>
              <Button variant="bordered" onClick={() => onVoteRestart(false)}>
                <Trans>Decline</Trans>
              </Button>
              <Button variant="green" onClick={() => onVoteRestart(true)}>
                <Trans>Agree</Trans>
              </Button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
